import request from 'helpers/request';
import api from 'config';

// 예약 목록
export const BookingDateSel = (params) => {
  return request({
    url: api.config.companyAPI + '/booking/v2/report',
    params
  });
};

// 예약 상세
export const BookingTimeSel = (params) => {
  return request({
    url: api.config.companyAPI + '/booking/v2/report/history',
    params
  });
};

// 예약 통계
export const BookingStatsSel = (params) => {
  return request({
    url: api.config.companyAPI + '/stat/v1/booking',
    params
  });
};
